export default __webpack_public_path__ + "static/foto-1-2458570d3d70ee7e226371f18455adee.jpg";